export const dayFields = (month, year) => {
	const daysInMonth = (32 - new Date(year, month-1, 32).getDate())
	let dayOptions = [{ label: 'Day', value: 0 }]
	for (let i=1; i<=daysInMonth; i++) {
		dayOptions.push({ label: i, value: i })
	}
	return dayOptions
}

export const monthFields = () => {
	let months = ['Month', 'January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
	return months.map((month, index) => ({ label: month, value: index }))
}

export const yearFields = () => {
	let yearOptions = []
	for (let i=1900; i<=new Date().getFullYear(); i++) {
		yearOptions.push({ label: i, value: i })
	}
	yearOptions.push({ label: 'Year', value: 0 })
	return yearOptions
}

export const hourFields = () => {
	let hourOptions = [{ label: '12', value: 12 }]
	for (let i=1; i<=11; i++) {
		const label = i.toString()
		hourOptions.push({ label, value: i })
	}
	return hourOptions
}

export const minuteFields = () => {
	let minuteOptions = [{ label: '00', value: '0' }]
	for (let i=1; i<=59; i++) {
		const label = i < 10 ? '0' + i.toString() : i.toString()
		minuteOptions.push({ label, value: i })
	}
	return minuteOptions
}



// WEBPACK FOOTER //
// ./src/Components/Display/DropdownValues.js